import { axiosInstance } from "@/lib/axiosInstance";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ApplicationType {
  id: string;
  student_id: string;
  college_id: string;
  internship_id: string;
  recruiter_tenant_id: string;
  resume_id: string | null;
  cover_letter: string | null;
  status: string;
  applied_at: string;
  updated_at: string;
}

export interface ApplicationCreatePayload {
  internship_id: string;
  resume_id?: string | null;
  cover_letter?: string | null;
}

export interface PaginatedApplications {
  items: ApplicationType[];
  total: number;
  page: number;
  limit: number;
}

export interface ApplicationListParams {
  status?: string | null;
  page?: number;
  limit?: number;
}

// ─── Service Functions ────────────────────────────────────────────────────────

export const applyForInternship = async (
  payload: ApplicationCreatePayload
): Promise<ApplicationType> => {
  const res = await axiosInstance.post("/v1/applications", payload);
  return res.data;
};

export const fetchApplications = async (
  params?: ApplicationListParams
): Promise<PaginatedApplications> => {
  const res = await axiosInstance.get("/v1/applications", { params });
  const raw = res.data;
  // Handle {success, data: {items, total, page, limit}} wrapping
  if (raw?.data?.items) return raw.data as PaginatedApplications;
  if (raw?.items) return raw as PaginatedApplications;
  return raw;
};

export const fetchApplicationById = async (
  applicationId: string
): Promise<ApplicationType> => {
  const res = await axiosInstance.get(`/v1/applications/${applicationId}`);
  const raw = res.data;
  return raw?.data || raw;
};

export const withdrawApplication = async (
  applicationId: string
): Promise<{ message: string }> => {
  const res = await axiosInstance.delete(`/v1/applications/${applicationId}`);
  return res.data;
};
